import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Small = makeShortcode("Small");
const DateUpdated = makeShortcode("DateUpdated");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2 {...{
      "id": "uses",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#uses",
        "aria-label": "uses permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Uses`}</h2>
    <Small mdxType="Small">
  Last updated: <DateUpdated date={`2019-12-07`} small={`true`} mdxType="DateUpdated" />
    </Small>
    <p>{`All the equipment and tools I use on a daily basis.`}</p>
    <p>{`For home, I use Ubuntu 19.10 in place of Windows now. Windows is still
a good platform for web development and if you are a Windows user you
can see how to use Windows Subsystem Linux for web development in
`}<a parentName="p" {...{
        "href": "https://ss10.me/wsl-2019"
      }}>{`this guide`}</a>{`, I also made a video for setting up `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=eSAsdQuQ-1o"
      }}>{`Ubuntu for web
development`}</a>{`.`}</p>
    <h3 {...{
      "id": "at-home-desk",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#at-home-desk",
        "aria-label": "at home desk permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`At home: Desk`}</h3>
    <ul>
      <li parentName="ul">{`My computer is an ASUS Transformer Pro T304UA`}</li>
      <li parentName="ul">{`Desk chair is a `}<a parentName="li" {...{
          "href": "https://amzn.to/2ZKWKQa"
        }}>{`HÅG Capisco Puls`}</a></li>
      <li parentName="ul">{`I run two `}<a parentName="li" {...{
          "href": "https://amzn.to/2ZKVMUP"
        }}>{`HP EliteDisplay's E232 58,4 cm (23")`}</a>{` Monitors through a
Dell 452-BBOO USB 3.0 Ultra HD Triple Video Docking Station.`}</li>
      <li parentName="ul">{`Keyboard is a `}<a parentName="li" {...{
          "href": "https://www.amazon.co.uk/gp/product/B0767YQQTQ/ref=ox_sc_saved_title_1?smid=A144NZUZAZWQSX&psc=1"
        }}>{`HAVIT KB395L`}</a>{`, (Kailh Low Profile Blue Switches)
really nice Kailh choc switches 👍`}</li>
      <li parentName="ul">{`Microphone, a `}<a parentName="li" {...{
          "href": "https://amzn.to/2N1uDWK"
        }}>{`Fifine Usb Cardioid Studio Condenser Microphone`}</a>{`
which is surprisingly good quality for the price.`}</li>
    </ul>
    <h3 {...{
      "id": "editor--terminal",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#editor--terminal",
        "aria-label": "editor  terminal permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Editor + Terminal`}</h3>
    <ul>
      <li parentName="ul">{`Microsoft `}<a parentName="li" {...{
          "href": "https://code.visualstudio.com/"
        }}>{`Visual Studio Code`}</a>{` with `}<a parentName="li" {...{
          "href": "https://github.com/sdras/"
        }}>{`Sarah Drasner`}</a>{`'s awesome `}<a parentName="li" {...{
          "href": "https://github.com/sdras/night-owl-vscode-theme"
        }}>{`Night
Owl`}</a>{` 🦉 theme`}</li>
      <li parentName="ul">{`Terminal of choice is `}<a parentName="li" {...{
          "href": "https://github.com/gnunn1/tilix"
        }}>{`Tilix`}</a>{`.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://dank.sh/"
        }}>{`Dank Mono`}</a>{` font for both text editor and terminal.`}</li>
    </ul>
    <h3 {...{
      "id": "desktop-apps",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#desktop-apps",
        "aria-label": "desktop apps permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Desktop Apps`}</h3>
    <ul>
      <li parentName="ul">{`I use `}<a parentName="li" {...{
          "href": "OBS"
        }}>{`Open Broadcaster Software`}</a>{` for recording some coding
sessions.`}</li>
      <li parentName="ul">{`For light video editing I use `}<a parentName="li" {...{
          "href": "https://www.openshot.org/"
        }}>{`OpenShot Video Editor`}</a></li>
    </ul>
    <h3 {...{
      "id": "at-work-desk",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#at-work-desk",
        "aria-label": "at work desk permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`At work: Desk`}</h3>
    <ul>
      <li parentName="ul">{`My work computer is a i9 `}<a parentName="li" {...{
          "href": "https://amzn.to/30ZX76C"
        }}>{`MackBook Pro (15-inch, 2019)`}</a></li>
    </ul>
    <h3 {...{
      "id": "editor--terminal-1",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#editor--terminal-1",
        "aria-label": "editor  terminal 1 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Editor + Terminal`}</h3>
    <ul>
      <li parentName="ul">{`Microsoft `}<a parentName="li" {...{
          "href": "https://code.visualstudio.com/"
        }}>{`Visual Studio Code`}</a>{` with `}<a parentName="li" {...{
          "href": "https://github.com/sdras/"
        }}>{`Sarah Drasner`}</a>{`'s awesome `}<a parentName="li" {...{
          "href": "https://github.com/sdras/night-owl-vscode-theme"
        }}>{`Night
Owl`}</a>{` 🦉 theme`}</li>
      <li parentName="ul">{`Hyper with Fish and Oh My Fish`}</li>
    </ul>
    <h3 {...{
      "id": "desktop-apps-1",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#desktop-apps-1",
        "aria-label": "desktop apps 1 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Desktop apps`}</h3>
    <ul>
      <li parentName="ul">{`For gif capture I use Kap.`}</li>
      <li parentName="ul">{`For installing any apps I'm using `}<a parentName="li" {...{
          "href": "https://cheatsheets.xyz/homebrew/"
        }}>{`Homebrew`}</a>{`.`}</li>
    </ul>
    {
      /* Links */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      